import React from "react";

const StepProgress = ({ step, activeTab }) => {

  // define steps per tab
  const totalSteps = {
    parking: 2,
    desking: 2,
    meeting: 3
  };

  const steps = totalSteps[activeTab] || 3;

  return (
    <div className="position-relative">
      <div className="progress step-number d-flex">
        {Array.from({ length: steps }).map((_, index) => (
          <span
            key={index}
            className={`progress-step ${step === index ? "active" : ""}`}
            // className={`progress-step ${step >= index ? "active" : ""}`}
          >
            {index + 1}
          </span>
        ))}

      </div>
    </div>
  );
};

export default StepProgress;